import React, { Component } from 'react'
import Slider from '@material-ui/lab/Slider';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const SliderStyled = withStyles({
    root: {
      paddingTop: '8px',
      marginBottom: '6px'
    },
    thumb: {
      backgroundColor: '#427175',
    },
    track: {
      backgroundColor: '#427175',
    }
  })(Slider);

class VolumeSlider extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      volume: (props.defaultValue ? props.defaultValue : 0)
    }
  }

  handleOnChange(event, value) {

    console.log('value', value);

    this.setState({
      volume: value
    });
    
    if(typeof this.props.changeCallback !== 'undefined') {
      this.props.changeCallback(value);
    }
  }

  render() {

    if(typeof this.props.value !== 'undefined') {
      var volume = this.props.value;
    } else {
      var { volume } = this.state;
    }

    if(typeof this.props.enabled === 'boolean' && !this.props.enabled) {
      return null;
    }
    
//rgb(0, 150, 138)
    return (
       <div style={{
          padding: '5px 10px',
          bottom: 0, 
          margin: '6px 10px 0px 0px',
          height: '60px',
          width: '200px', 
          boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
          <SliderStyled
            className="slider-control"
            value={volume}
            onChange={this.handleOnChange.bind(this)}
            min={0}
            max={100}
            sliderstyle={{marginBottom:'0px', marginTop: '5px'}}
          />
        <div>{this.props.name}</div>
      </div>
    );
  }
}

VolumeSlider.propTypes = {
  name: PropTypes.string,
  changeCallback: PropTypes.func,
  defaultValue: PropTypes.number,
  color: PropTypes.string,
  value: PropTypes.number //optional
};


export {VolumeSlider}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/slider/index.js